import { ModelMailHandler } from "@/type/core/models/models.types";
import { useUnit } from "effector-react";
import { modelMailStore } from "@state/modelMail/ModelMailStore";

export const useModelMail = (): ModelMailHandler => {
  const modelMailHandler = useUnit<ModelMailHandler>(modelMailStore);

  return {
    selectedOffice: modelMailHandler.selectedOffice,
  };
};
